import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Grid, Typography, useTheme, useMediaQuery, Button, Box } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { SalesOrderCreateForm } from '../../features/salesOrder/components/SaleOrderCreateForm';
import routes from 'constants/routes';

export const SalesOrderCreatePage = (): JSX.Element => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Layout>
			<Grid container paddingY={isMobile ? 2 : 5} justifyContent={'center'}>
				<Grid item xs={12} display="flex" justifyContent={'center'}>
					<Typography
						variant={isMobile ? 'h5' : 'h6'}
						sx={{
							fontWeight: 'bold',
							fontSize: isMobile ? '1.5rem' : '1.25rem',
							mb: isMobile ? 2 : 0,
							textAlign: 'center',
						}}
					>
						Nueva Orden de Venta
					</Typography>
				</Grid>
				<Grid container justifyContent="center" paddingY={isMobile ? 1 : 5}>
					<Box width="100%" maxWidth={600} display="flex" flexDirection="column" alignItems="stretch" gap={2}>
						<Button component={RouterLink} to={routes.salesOrder.newFromQuotation} variant="outlined" color="primary">
							Crear desde cotización (asistente)
						</Button>
						<SalesOrderCreateForm />
					</Box>
				</Grid>
			</Grid>
		</Layout>
	);
};
